import { Action, Dispatch } from "redux";
import { Language, Map } from "typings";
import API from "../../services/api";
import { createStatusMessage } from "../ui/StatusMessage";
import { statusAdd } from "../ui/action";

export interface LoadLanguages extends Action
{
    type: "LOAD_LANGUAGES";
    languages: Language[];
}

export interface LoadTranslation extends Action
{
    type: "LOAD_TRANSLATION";
    language: string;
    translations: Map<string>;
}

export interface LoadFieldTranslationAction extends Action
{
    type: "LOAD_FIELD_TRANSLATION";
    language: string;
    translations: Map<Map<string>>;
}

export interface RemoveFieldAction extends Action
{
    type: "REMOVE_FIELD";
    fieldName: string;
  
}

export interface NewFieldAction extends Action
{
    type: "NEW_FIELD";
    fieldName: string;
}


export interface LoadAllAvailableLanguagesAction extends Action
{
    type: "LOAD_ALL_AVAILABLE_LANGUAGES";
    languages: Language[];
}


export interface UpdateFieldAction extends Action
{
    type: "UPDATE_FIELD";
    language: string;
    fieldName: string;
    value: string;

}

export const loadLanguages = () => async (dispatch: Dispatch<Action>) =>
{
    try
    {
        const languages = await API.translation.getLanguages();
        const action: LoadLanguages = { type: "LOAD_LANGUAGES", languages };
        dispatch(action);
    }
    catch
    {
        const error = createStatusMessage("Loading languages failed", "error", "export");
        dispatch(statusAdd(error));
    }
};

export const loadTranslations =  (language: string) => async (dispatch: Dispatch<Action>) =>
{
    try
    {
        const translations = await API.translation.getTranslation(language);
        const action: LoadTranslation = { type: "LOAD_TRANSLATION", translations, language };
        dispatch(action);
    }
    catch
    {
        const error = createStatusMessage(`Loading translation for ${language} failed`, "error", "export");
        dispatch(statusAdd(error));
    }
};

export const loadFieldTranslations =  (language: string) => async (dispatch: Dispatch<Action>) =>
{
    try
    {
        const translations = await API.translation.getFieldTranslations(language);
        const result = translations.reduce((result, value) => ({...result, [value.fieldName]: value.dictionary}) , {});
        const action: LoadFieldTranslationAction = { type: "LOAD_FIELD_TRANSLATION", translations: result, language };
        dispatch(action);
    }
    catch
    {
        const error = createStatusMessage(`Loading field translation for ${language} failed`, "error", "export");
        dispatch(statusAdd(error));
    }
};



export const addLanguage = (language: string) => async (dispatch: Dispatch<any>) =>
{
    try
    {
        await API.translation.newLanguage(language);
        await dispatch(loadLanguages());
    }
    catch
    {
        const error = createStatusMessage(`Creating ${language} failed`, "error", "export");
        dispatch(statusAdd(error));
    }
};

export const createField = (fieldName: string) => async (dispatch: Dispatch<any>) =>
{
    try
    {
        await API.translation.createField(fieldName);
        const action: NewFieldAction = { type: "NEW_FIELD", fieldName };
        dispatch(action);
    }
    catch (e)
    {
        const error = createStatusMessage(`Creating ${fieldName} failed`, "error", "export");
        dispatch(statusAdd(error));
    }
};

export const removeField = (fieldName: string) => async (dispatch: Dispatch<any>) =>
{
    try
    {
        await API.translation.removeField(fieldName);
        const action: RemoveFieldAction = { type: "REMOVE_FIELD", fieldName };
        dispatch(action);
    }
    catch
    {
        const error = createStatusMessage(`Remove ${fieldName} failed`, "error", "export");
        dispatch(statusAdd(error));
    }
};

export const updateField = (language: string, fieldName: string, value: string) => async (dispatch: Dispatch<any>) =>
{
    try
    {
        await API.translation.updateField(language, fieldName, value);
        const action: UpdateFieldAction = { type: "UPDATE_FIELD", language, fieldName, value };
        dispatch(action);
    }
    catch
    {
        const error = createStatusMessage(`Update ${fieldName} failed`, "error", "export");
        dispatch(statusAdd(error));
    }
};

export const loadAllAvailableLanguages = () => async (dispatch: Dispatch<any>) =>
{
    try
    {
        const languages = await API.translation.getAllLanguages();
        const action: LoadAllAvailableLanguagesAction = { type: "LOAD_ALL_AVAILABLE_LANGUAGES", languages };
        dispatch(action);
    }
    catch
    {
        const error = createStatusMessage(`loading language list failed`, "error", "export");
        dispatch(statusAdd(error));
    }
};




export type TranslationActions = 
    LoadLanguages |
    LoadTranslation |
    RemoveFieldAction |
    NewFieldAction |
    UpdateFieldAction |
    LoadAllAvailableLanguagesAction |
    LoadFieldTranslationAction;







// WEBPACK FOOTER //
// ./src/state/translation/action.ts